import * as React from "react";
const SvgCaretDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#220C4A", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 15L18 9H6L12 15Z", fill: "" }));
export default SvgCaretDown;
